import { createAction } from '@reduxjs/toolkit';
import { WithdrawalMethodsResponse } from './withdrawal.types';

export const updateWithdrawalMethods = createAction<
  WithdrawalMethodsResponse['responseObject'],
  'withdrawal/UPDATE_WITHDRAWAL_METHODS'
>('withdrawal/UPDATE_WITHDRAWAL_METHODS');
